/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon20Solid = forwardRef('AttachLinkIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M0 10a6 6 0 0 1 6-6h1.75a1 1 0 0 1 0 2H6a4 4 0 1 0 0 8h1.75a1 1 0 1 1 0 2H6a6 6 0 0 1-6-6Z" }),
        React.createElement("path", { d: "M20 10a6 6 0 0 0-6-6h-1.75a1 1 0 1 0 0 2H14a4 4 0 0 1 0 8h-1.75a1 1 0 1 0 0 2H14a6 6 0 0 0 6-6Z" }),
        React.createElement("path", { d: "M6 9a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H6Z" })));
});
